import NavBar from "./NavBar";
import Footer from "./Footer";
import { Button, Card, Flex, Text } from "@radix-ui/themes";
import React from "react";
import { TypeAnimation } from "react-type-animation";
import AudioPlayer from "./AudioPlayer";

const HomePage = () => {
  return (
    <div style={styles.pageContainer}>
      <NavBar />
      <main style={styles.content}>
        {/* Put all contents inside here */}
        <Card size="5">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Flex
              display="flex"
              direction="column"
              align="center"
              justify="center"
              gap="6"
              style={{
                textAlign: "center",
              }}
            >
              <div>
                <Text
                  size="9"
                  weight="bold"
                  style={{
                    maxWidth: "50%",
                  }}
                >
                  AI Powered
                </Text>
                <br />
                <Text
                  size="9"
                  weight="bold"
                  style={{
                    maxWidth: "50%",
                  }}
                >
                  Audio Learning Platform
                </Text>
              </div>

              <div>
                <Text
                  weight="light"
                  color="white"
                  style={{
                    maxWidth: "60%",
                  }}
                >
                  Built to make learning
                </Text>
                <br />
                <Text
                  weight="light"
                  color="white"
                  style={{
                    maxWidth: "60%",
                  }}
                >
                  accessible and effortless,
                </Text>
                <br />
                <Text
                  weight="light"
                  color="white"
                  style={{
                    maxWidth: "60%",
                  }}
                >
                  <span style={{ color: "#009951" }}>Tellos AI</span> transforms
                  any topic into engaging audio content with AI.
                </Text>
              </div>

              <Button
                size="4"
                variant="soft"
                color="green"
                style={{ cursor: "pointer", height: "4rem" }}
                onClick={() =>
                  (window.location.href = "http://app.iamtellos.com")
                }
              >
                <>
                  <Text>Start learning</Text> —{" "}
                  <Text weight="light">for free</Text>
                </>
              </Button>
            </Flex>
          </div>
        </Card>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingTop: "50px",
          }}
        >
          <Flex
            display="flex"
            direction="column"
            align="center"
            justify="center"
            gap="6"
            style={{
              textAlign: "center",
            }}
          >
            <div>
              <Text size="6" weight="medium">
                1. Create
              </Text>{" "}
              —{" "}
              <Text size="3" weight="light">
                Enter a topic or phrase that sparks your curiosity
              </Text>
              <div style={{ marginTop: "20px" }}>
                <TypeAnimation
                  sequence={[
                    "Summary of The Fabric of Reality.",
                    5000,
                    "Explain Allegory of the cave.",
                    5000,
                  ]}
                  speed={50}
                  style={{ fontSize: "40px", fontWeight: "lighter" }}
                  repeat={Infinity}
                />
              </div>
            </div>

            <div>
              <Text size="6" weight="medium">
                2. Learn
              </Text>{" "}
              —{" "}
              <Text size="3" weight="light">
                Listen and expand your knowledge.
              </Text>
              <AudioPlayer />
            </div>
          </Flex>
        </div>

        {/* Footer comment out because the content is too short. */}
        {/* <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "50px",
          }}
        >
          <Flex
            display="flex"
            direction="column"
            align="center"
            justify="center"
            gap="6"
            style={{
              textAlign: "center",
            }}
          >
            <div>
              <Text
                size="7"
                weight="medium"
                style={{
                  maxWidth: "50%",
                }}
              >
                Try Tellos for free now
              </Text>
              <br />
            </div>

            <Button
              size="4"
              variant="soft"
              color="green"
              style={{ cursor: "pointer" }}
            >
              <Text>Start learning</Text>—<Text weight="light">for free</Text>
            </Button>
          </Flex>
        </div> */}
      </main>
      <Footer />
    </div>
  );
};

const styles = {
  pageContainer: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
  content: {
    flex: 1,
    padding: "50px",
  },
};

export default HomePage;
